import React from 'react';
import PropTypes from 'prop-types';

const SortApplicationRenderer = ({
  position,
  firstName,
  lastName,
  schoolType,
  score,
  rowStyle, // nový prop: externý štýl riadku
  accentColor, // nový prop: voliteľný ľavý pásik
  className, // voliteľne, ak chceš doplniť className
}) => {
  return (
    <div style={{ ...styles.row, ...rowStyle }} className={className}>
      {accentColor ? (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: 6,
            top: 6,
            bottom: 6,
            width: 6,
            borderRadius: 6,
            background: accentColor,
            opacity: 0.7,
          }}
        />
      ) : null}

      <div style={styles.cell}>{position ?? '-'}</div>
      <div style={styles.cell}>
        {firstName} {lastName}
      </div>
      <div style={styles.cell}>{schoolType || '—'}</div>
      <div style={styles.cell}>
        <div>Koeficient: <strong>{score ?? '—'}</strong></div>
        {score !== null && score !== undefined && (
          <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
            Poradie: {position ?? '—'}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  row: {
    position: 'relative', // aby accent pásik sedel
    display: 'grid',
    gridTemplateColumns: '0.5fr 1.2fr 1fr 0.8fr',
    gap: 10,
    padding: 10,
    borderBottom: '1px solid #ccc',
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
  },
  cell: {
    textAlign: 'left',
    padding: '0 10px',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

SortApplicationRenderer.propTypes = {
  position: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  schoolType: PropTypes.string,
  score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowStyle: PropTypes.object,
  accentColor: PropTypes.string,
  className: PropTypes.string,
};

export default SortApplicationRenderer;
